import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBbpmWHQ_5UUg9KT8VDuTtpotUtuzm8TbM",
  authDomain: "decoder-app-22d60.firebaseapp.com",
  projectId: "decoder-app-22d60",
  storageBucket: "decoder-app-22d60.firebasestorage.app",
  messagingSenderId: "196279311727",
  appId: "1:196279311727:web:f28e7b605f438369835c9a"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export { app };
